import { mapGetters } from "vuex";
import appConfig from "../../config/app_config";
import QuadrantObject from "@/objects/QuadrantObject";
import socketClient from "@/api/Client";
import _ from "lodash";

export const websocket_helper = {
    name: 'websocket_helper',
    computed: {
        ...mapGetters({
            _token: "auth/token"
        }),
    },
    watch: {
    },
    data() {
        return {
            configurationProperties: {
                init: 1,
                profile: {
                    connect: false
                },
                signalObjectMap: new Map()
            },
            signals: null,
            webSocket: {},
            sessionId: "",
            token: "",
        }
    },
    created() {
        window.EventBus.listen("linkingToRecieveRoutes", this.linkToTreeObject);

    },
    mounted() {
        this.signals = this.configurationProperties.signalObjectMap;

        this.generateSessionId();
        // if (
        //     !(
        //         !_.isEmpty(this.configurationProperties.profile) &&
        //         this.configurationProperties.profile.hasOwnProperty("connect") &&
        //         this.configurationProperties.profile.connect === false
        //     )
        // ) {
            this.connect();
        // } else {
        //     console.log("component without connection", this.configurationProperties);
        // }
    },
    beforeDestroy() {
        window.EventBus.removeListener(
            "linkingToRecieveRoutes",
            this.linkToTreeObject
        )

        if (
            !(
                !_.isEmpty(this.configurationProperties.profile) &&
                this.configurationProperties.profile.hasOwnProperty("connect") &&
                this.configurationProperties.profile.connect === false
            )
        ) {
            this.disconnect();
        }
    },
    methods: {

        addLinkListener() {
            if (
                !_.isEmpty(this.configurationProperties.profile) &&
                this.configurationProperties.profile.hasOwnProperty("relink") &&
                this.configurationProperties.profile.relink == true
            ) {
                window.EventBus.listen("linkToTreeObject", this.linkToTreeObject);
            }
        },
        removeLinkListener() {
            if (
                !_.isEmpty(this.configurationProperties.profile) &&
                this.configurationProperties.profile.hasOwnProperty("relink") &&
                this.configurationProperties.profile.relink == true
            ) {
                window.EventBus.removeListener(
                    "linkToTreeObject",
                    this.linkToTreeObject
                )
            }
        },
        generateSessionId() {
            let _sessionId = this.$store.getters["auth/userName"];
            const dummyToken = "eyJhbGciOiAiUlMyNTYiLCAidHlwIjogIkpXUyJ9.eyJpc3MiOiAidGhlZHJpdmluZ2ZvcmNlLm5sIiwgImV4cCI6IDE1NzI0MzA4MjQwODgsICJuYmYiOiAxNTY5ODM4ODI0MDg4LCAiaWF0IjogMTU2OTgzODgyNDA4OCwgImp0aSI6ICJSa2c0TjFneFRrRT0ifQ==.oHHKtS0mBeucQj0BkA1RpY6CQc5xhW/Wxcp01MjHwfYoyXjJ/c2V2qRgfklbZiCuV7OD4q1TFUJOJRBauAcjGQCPwEDbBUt9OlqQ6wu3VYzISpKDI6yIgr8ICg7xF6tOGR7B/to4dB/NgHWWSbx2BsVcrMgiUH7/TNlNH12bxUr93nMLusGJZJBJiY7f4N3Vi1zTsL2/6K3+cSpun9FwQGpobcItA72qaJqpkg99QRe7kc/rLPwb4ct2SxhiYfFWGRfw0TBu0YnBPAEnf8jAO2mlCgieU1Dfrg062p19kuqlvOF/Rj25P1dRBWe0BY0iSLcENlsACQc23R6pHSRZ0g=="
            if (this._token == "" || this._token == null) {
                this.token = dummyToken;
            } else {
                this.token = this._token;
            }

            // if (appConfig.test) {
            //     if (_sessionId == "" || this.token == "" || this.token == null) {
            //         _sessionId = "development@thedrivingforce.nl";
            //         this.token =
            //             "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjdiZTQxN2M4NGIyNTM5MmRjZTU4ODQzMmI2M2MyMzZiMGZiZDY0MDA3NTUwYTE0NTA3YjYxMjdiYzdhY2UyZDQxMGJkY2MwZTkzMGFkODMwIn0.eyJhdWQiOiIzIiwianRpIjoiN2JlNDE3Yzg0YjI1MzkyZGNlNTg4NDMyYjYzYzIzNmIwZmJkNjQwMDc1NTBhMTQ1MDdiNjEyN2JjN2FjZTJkNDEwYmRjYzBlOTMwYWQ4MzAiLCJpYXQiOjE1MzMzMDgxMTIsIm5iZiI6MTUzMzMwODExMiwiZXhwIjoxNTY0ODQ0MTEyLCJzdWIiOiIxMDg2OSIsInNjb3BlcyI6WyIqIl19.HWNHo6rEyJvKgGnmpD-DTRNaE1JyH8oSVOMcLS2741QyomUbczyQoSCmoUkT4EmDvLSb0lnxVkIWknOYck_mLqJzcZfLkVKdXVoVeRdMHDtPVoOYQDEtYDhjud4Ce_ao50P6CdLxWvs7jy0EYzG61N5if5Xp9bt1SMzX5UixTUorNz1Sj0m-DHoLzcb3z3HLGhOVm-eQ1l7NwmmCUk9CawbGY3GN_fKQyweF1fP4s9HUGhr08lg9gFKZZ5R0HxtBLGTXcWLDVtaxVQw1LSMNDTN-m3xXWIyvu9ljc-rnJ9nMbJmj2O9b6VSqc4tS0ifsP4j59kZ8R3eroluTzU39RygRL__fACgZBFBe_T6M02UaLt6qjxpx9A_crjwFOUs5rF130d4FPCVnaybGuIBsAgpfGqBSG2U3r-fRQz87vLYArGk33gtNP21e6wnUsN98-yto7vz9d3bcpPmFnisJS7YFhDzhJ9pP7Py4R38Xli405HemlAcWYRWEmxwPo4BWFAPgefDiccnXWQkFRpLmOL-O6mOshYMt6HD6tBW51nmGcjJ5XdC99UXWCVwWkk4sJay21qY-ktOcXq0fpxmXUUE7LArQyPFPNAs6Ftc2G0RB5DRd8MmjPXWfuJVJ2m9yHaWcJInFZoT5zKj6KqdN147rak-kXpj-5CVOO6Zhd4E";
            //         this.$store.commit("auth/setToken", this.token);
            //     }
            // }
            this.sessionId = _sessionId +=
                "_" + this.$options.name + "_" + QuadrantObject._createPinCode();
            this.removeLinkListener();
            this.addLinkListener();
        },
        linkToTreeObject(data) {
            console.log(" LINKING THIS", data)
            let nuObj = data.id;
            if (this.lastObject != nuObj) {
                window.EventBus.fire("PreventReload", true);
                this.beforeCleanWebSocket();
                this.signals = this.getPlainSignalMap(nuObj);
                this.unlinkToAllSignals();
            }
            this.lastObject = nuObj;
        },
        getPlainSignalMap(object) {
            return new Map().set(object, [
              ["locationAspectUpdate", ["LocationAspectData"]],
              ["incidentAspectUpdate", ["IncidentAspectData"]],
              ["userAspectUpdate", ["UserAspectData"]],
              ["routeAspectUpdate", ["RouteAspectData"]],
              ["CapacityUpdate", ["CapacityData"]],
              ["userLocationUpdate", ["userLocationData"]],
              ["weatherUpdate", ["WeatherUpdate"]]
            ]);

          },
        beforeCleanWebSocket() {
        },
        disconnect() {
            this.removeLinkListener();
            this.stopWebSocket();
        },
        reconnect() {
            console.log("BaseQuadrant reconnect");
            this.connect();
        },
        connect() {
            this.createWebSocket();
        },
        createWebSocket() {
               this.webSocket = new socketClient(
                this.onBaseEvent,
                this.sessionId,
                this.token,
                this.signals,
                this.onConnectionStatus
            );
            this.webSocket.start(this.autoConnect);
        },
        unlinkToAllSignals() {
            if (this.objectsLinked.length > 0) {
                for (let obj in this.objectsLinked) {
                    this.doUnlinkAndDisconnect(this.objectsLinked[obj]);
                }
            }
        },
        stopWebSocket() {
            this.webSocket.stop(true);
        },
        autoConnect() {
            this.objectsLinked = [];
            if (this.signals != undefined && this.signals.size > 0) {
                this.signals.forEach((value, key, map) => {
                    this.doLinkAndConnect(key, value);
                });
            } else {
                console.warn("No specified signals for component ", this.sessionId);
            }
        },
        onConnectionStatus(event) {
            console.warn("onConnectionStatus", this.sessionId, event == "CloseEvent");
            // How do we check a proper close from a disconnect ?
            if (event == null) {
                console.log("BaseQuadrant regenerate session id", event);
                this.generateSessionId();
                return this.sessionId;
            }
        },
        onBaseEvent(data) {
            this.onEvent(data);
        },

        doLinkAndConnect(object, signalsList) {
            console.log(
                "doLinkAndConnect ",
                this.sessionId,
                object,
                signalsList,
                this.objectsLinked,
                this.webSocket.args
            );
            if (signalsList[0][0] !== 'locationAspectUpdate') {
              if (!this.objectsLinked.includes(object)) {
                let request = JSON.parse(JSON.stringify(this.webSocket.args));
                request.signals = {
                };
                signalsList.forEach((signal, index) => {
                  request.signals["sig" + index] = signal[0];
                });
              }
            }
        },
        doUnlinkAndDisconnect(object) {
            console.log(
                "doUnlinkAndDisconnect ",
                object
            );
        },
        onEvent(container) {
        },
    }
}
